import { useContext, useEffect, useRef, useState } from "react";
import EmojiPicker from "emoji-picker-react";
import AwsServerService from "../../common/util/AwsServerService";
import { useSelector } from "react-redux";
import JoditTextEditor from "../../common/JoditEditor/JoditTextEditor";
import parse from "html-react-parser";
import "../Task/TaskCommentSection.css";
import { Popover, message } from "antd";
import TaskService from "../../common/util/TaskService";
import { getSocket } from "../../Socket";
import Draggable from "react-draggable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAt, faTags } from "@fortawesome/free-solid-svg-icons";
import AppContext from '../../Context/AppContext';
import CommentEditor from "../../common/JoditEditor/CommentEditor";

const TaskCommentSection = ({taskData, taskDataId, taskType, taskId, allUsers, taskListComment, allPipelineData, messageBehavior, messageBehaviorRef, createTaskModal}) => {
  let allDealsAndUsers = useSelector((state) => state.AppReduxContext.AllDeals || []);
  const AppData = useContext(AppContext);
  const { state, dispatch } = AppData || {};
  const allAccounts = state.AllAccounts || [];
  const socket = getSocket();
  const userInfo = JSON.parse(localStorage.getItem("userinfo"));
  const [comments, setComments] = useState([]);
  const [commentInput, setCommentInput] = useState("");
  const [replyTo, setReplyTo] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);

  const [openPopoverId, setOpenPopoverId] = useState(null);
  const [showFullEmojiPickerFor, setShowFullEmojiPickerFor] = useState(null);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [showEditorPopover, setShowEditorPopover] = useState(false);

  const [pinnedCommentId, setPinnedCommentId] = useState(null);

  const bottomRef = useRef(null);
  const inputRef = useRef(null);
  
  const [dealAccountList, setDealAccountList] = useState([]);
  useEffect(()=>{
    if(allDealsAndUsers){
      let arr=[];

      allDealsAndUsers.forEach(e=>{
        let account = allAccounts.find(
          k => k.Account_Name == e.Account_Name?.name
        )

        let obj = {
          id: e.id,
          Deal_Name: e.Deal_Name,
          Account_Name: e.Account_Name?.name,
          AccountColor: account ? account.Color : "#5b6c97",
          DealColor: "#5b6c97",
        }

        arr.push(obj);
      });
      setDealAccountList(arr)
    }
  },[allDealsAndUsers, allAccounts])
  useEffect(() => {
    if (taskId && taskType) loadComments();
  }, [taskId, taskType]);
  const commentRefs = useRef({});
  const loadComments = () => {
    AwsServerService.getTaskRelatedComments(taskId, taskType)
      .then((res) => setComments(res.data || []))
      .catch((err) => console.error(err));
  };
  
  const sendMentionNotification = async (data, type, commentId) => {
      if (!data || data.length === 0) return;
      // let selectedDealname = allPipelineData?.find(e=>e.PipelineROWID==taskData?.PipelineROWID)['DealName']
      let taskType ;
      let selectedDealname;
      if (taskData?.hasOwnProperty("SubTaskROWID")) {
        taskType = "SubTask";
        for (const pipeline of allPipelineData || []) {
          for (const task of pipeline.Tasks || []) {
            const subtaskMatch = (task.SubTasks || []).find(
              (subtask) => subtask.SubTaskROWID === taskData.SubTaskROWID
            );
            if (subtaskMatch) {
              selectedDealname = pipeline.DealName;
              break;
            }
          }
          if (selectedDealname) break;
        }
      } else if (taskData?.PipelineROWID) {
        taskType = "Task";
        selectedDealname = allPipelineData?.find(
          (e) => e.PipelineROWID === taskData.PipelineROWID
        )?.DealName;
      }

      let lookUpDeal = allDealsAndUsers.find(d=> d.Deal_Name == selectedDealname);
      let clientColor = "";
      let dealColor = "";
      if(lookUpDeal){
        clientColor=await TaskService.GetClientColor(lookUpDeal?.Account_Name.id);
        dealColor=await TaskService.GetDealColor(lookUpDeal?.Stage);
      }
      // const notifyArray = mentionedUsers
      let notifyArray ;
      const commentAuthor = `${userInfo?.first_name} ${userInfo?.last_name}`;
      let mentionText;
      if(type == "Mention"){
        notifyArray = data.map(user => user.zuid);
        mentionText = `<a style="color:#40a9ff" id="User-${userInfo?.email_id}">${commentAuthor}</a>
          <span> mentioned you in a <a style="color:#40a9ff" id="TaskComment-${commentId}">comment</a> in </span>
          <a style="color:#40a9ff" id="${taskType == 'Task' ? 'Task-' + taskData?.TaskId : 'SubTask-' + taskDataId +"/"+taskData?.SubTaskId}">${taskData?.TaskName}</a>
          <a style="background-color:${clientColor}" id="Client-${lookUpDeal.Account_Name.id}">
          ${lookUpDeal.Account_Name?.name || ""}
          </a>  
          <a style="background:${dealColor}" id="Deal-${lookUpDeal.id}">
          ${lookUpDeal.Deal_Name}
          </a>`;
      } else if(type == "Reply"){
        const repliedComment = comments.find((com) => String(com.ROWID) === String(data));
        if(repliedComment?.CREATEDBY === userInfo?.email_id) return 0;
        notifyArray = allUsers.find((u) => u.email === repliedComment?.CREATEDBY)?.zuid;
        mentionText = `<a style="color:#40a9ff" id="User-${userInfo?.email_id}">${commentAuthor}</a>
          <span> replied to your comment </span>
          <a style="color:#40a9ff" id="TaskComment-${repliedComment?.ROWID}">"${repliedComment.Message}"</a><span> in </span>
          <a style="color:#40a9ff" id="${taskType == 'Task' ? 'Task-' + taskData?.TaskId : 'SubTask-' + taskDataId +"/"+taskData?.SubTaskId}">${taskData?.TaskName}</a>  
          <a style="background-color:${clientColor}" id="Client-${lookUpDeal.Account_Name.id}">
          ${lookUpDeal.Account_Name?.name || ""}
          </a>  
          <a style="background:${dealColor}" id="Deal-${lookUpDeal.id}">
          ${lookUpDeal.Deal_Name}
          </a>`;
      } else if(type == "Emoji"){
        const reactedComment = comments.find((com) => String(com.ROWID) === String(data.split(" ")[1]));
        if(reactedComment?.CREATEDBY === userInfo?.email_id) return 0;
        notifyArray = allUsers.find((u) => u.email === reactedComment?.CREATEDBY)?.zuid;
        mentionText = `<a style="color:#40a9ff" id="User-${userInfo?.email_id}">${commentAuthor}</a>
          <span> reacted to your comment <a style="color:#40a9ff" id="TaskComment-${reactedComment?.ROWID}">"${reactedComment.Message}"</a> with ${data.split(" ")[0]} in </span>
          <a style="color:#40a9ff" id="${taskType == 'Task' ? 'Task-' + taskData?.TaskId : 'SubTask-' + taskDataId +"/"+taskData?.SubTaskId}">${taskData?.TaskName}</a>
          <a style="background-color:${clientColor}" id="Client-${lookUpDeal.Account_Name.id}">
          ${lookUpDeal.Account_Name?.name || ""}
          </a>  
          <a style="background:${dealColor}" id="Deal-${lookUpDeal.id}">
          ${lookUpDeal.Deal_Name}
          </a>`;
      }
      try {
        await TaskService.SendNotificationToMultipleUsers(notifyArray, allUsers, "Task", mentionText);
        socket.emit("Refresh_Reminder_List","");
      } catch (error) {
        console.error("Error sending mention notifications:", error);
      }
    };
  const pinnedComment = comments.find(c => c.IsPinned == true || c.IsPinned == 1);
  const deleteComment = async (commentId) => {
    try {
      await AwsServerService.deleteComment(commentId);
      loadComments();
      setOpenPopoverId(null);
    } catch (err) {
      console.error(err);
    }
  };

  const togglePinComment = async (commentId) => {debugger
  try {

    const comment = comments.find((c) => c.ROWID === commentId);
    if (!comment) return;

    const currentlyPinned = comments.find((c) => c.IsPinned == true || c.IsPinned == 1);
    if (comment.IsPinned) {
      await AwsServerService.updateComment({
        ROWID: commentId,
        MODIFIEDBY: userInfo.email_id,
        IsPinned: 0
      });
    } else {
      if (currentlyPinned && currentlyPinned.ROWID !== commentId) {
        await AwsServerService.updateComment({
          ROWID: currentlyPinned.ROWID,
          MODIFIEDBY: userInfo.email_id,
          IsPinned: 0
        });
      }
      await AwsServerService.updateComment({
        ROWID: commentId,
        MODIFIEDBY: userInfo.email_id,
        IsPinned: 1
      });
    }
    loadComments();
    setOpenPopoverId(null);

  } catch (err) {
    console.error(err);
  }
};

  const handleReactToComment = (commentId, emoji, isRemove) => {
    const comment = comments.find((c) => c.ROWID === commentId);
    if (!comment) return;

    const currentReactions = comment.Reactions
      ? typeof comment.Reactions === "string"
        ? JSON.parse(comment.Reactions)
        : comment.Reactions
      : [];

    let updatedReactions;

    if (isRemove) {
      updatedReactions = currentReactions.filter(
        (r) => !(r.user === userInfo.email_id && r.emoji === emoji)
      );
    } else {
      updatedReactions = [...currentReactions, { user: userInfo.email_id, emoji }];
    }

    AwsServerService.addReaction(JSON.stringify(updatedReactions), commentId)
      .then(() => loadComments())
      .catch(console.error);
  };

  const getUserDetails = (email) =>
    allUsers?.find((u) => u.email === email) || {};

  const getUserThumbnailUrl = (zuid) =>
    "https://contacts.zoho.com/file?ID=" + zuid + "&fs=thumb";

  const isSameDay = (d1, d2) =>
    d1.getDate() === d2.getDate() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getFullYear() === d2.getFullYear();

  const getDateLabel = (date) => {
    const messageDate = new Date(date);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (isSameDay(messageDate, today)) return "Today";
    if (isSameDay(messageDate, yesterday)) return "Yesterday";

    return messageDate.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric"
    });
  };

  const formatTime = (rawDate) =>
    new Date(rawDate).toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit"
    });

  const saveCommentForTask = async (value) => {debugger
    if (!value || !value.trim()) return;
    const inputValue = value.altKey == false ? commentInput : value;
    const sourceTaskType = taskData?.SubTaskROWID ? "SubTask" : "Task";
    const sourceId = taskData?.SubTaskROWID
      ? taskData.SubTaskROWID
      : taskData.TaskROWID;

    try {
      const userNameToCheck = allUsers.filter(
        (user) => user.full_name !== userInfo.first_name + " " + userInfo.last_name
      );
      const detectedMentionedUsers = userNameToCheck.filter((user) =>
        inputValue.toLowerCase().includes(user.full_name.toLowerCase())
      );
      if (editingCommentId) {
        const commentPayload = {
            ROWID: editingCommentId,
            Message: inputValue,
            MODIFIEDBY: userInfo.email_id,
            TaskId: sourceId,
          };
        await AwsServerService.updateComment(commentPayload).then(res =>{
          if(detectedMentionedUsers.length > 0){
              sendMentionNotification(detectedMentionedUsers, "Mention",res.data[0]?.insertId);
            }
        });
        setEditingCommentId(null);
      } else {
        const commentPayload = {
            Message: inputValue,
            CREATEDBY: userInfo.email_id,
            TaskId: sourceId,
            TaskType: sourceTaskType,
            ReplyTo: replyTo ? replyTo.ROWID : null,
          };
        await AwsServerService.addComment(commentPayload).then(res =>{
          if(commentPayload.ReplyTo != null){
              sendMentionNotification(replyTo?.ROWID, "Reply",res.data[0]?.insertId)
            }
            if(detectedMentionedUsers.length > 0){
              sendMentionNotification(detectedMentionedUsers, "Mention",res.data[0]?.insertId);
            }
        });
      }

      loadComments();
      setCommentInput("");
      setReplyTo(null);

    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "auto" });
  }, [comments]);

  const renderMessage = (html) => parse(html || "");


  const popoverContent = (comment) => (
  <div style={{ width: 220 }}>

    <div style={{ display: "flex", gap: "8px", marginBottom: "8px" }}>
      {["❤️", "😂", "👍", "😮"].map((emoji) => (
        <span
          key={emoji}
          onClick={() => {
            handleReactToComment(comment.ROWID, emoji, false);
          }}
          style={{
            fontSize: "20px",
            cursor: "pointer",
            padding: "4px",
            borderRadius: "50%",
            background: "#f5f5f5"
          }}
        >
          {emoji}
        </span>
      ))}

      {!showFullEmojiPickerFor && (
        <div
          style={{
            cursor: "pointer",
            width: "28px",
            display: "flex",
            fontSize: "large",
            fontWeight: "600",
            background: "#ececec",
            borderRadius: "1rem",
            justifyContent: "center",
            height: "32px",
            alignItems: "center"
          }}
          onClick={() => setShowFullEmojiPickerFor(comment.ROWID)}
        >
          +
        </div>
      )}

      {showFullEmojiPickerFor === comment.ROWID && (
        <div style={{ position: "absolute", right: "100%", zIndex: 20 }}>
          <EmojiPicker
            onEmojiClick={(event, emojiData) => {
              handleReactToComment(comment.ROWID, emojiData.emoji, false);
            }}
          />
        </div>
      )}
    </div>

    <div style={{ borderTop: "1px solid #eee", margin: "8px 0" }} />

    <div
      style={{ padding: "6px", cursor: "pointer" }}
      onClick={() => {
        console.log("Reply:-",comment)
        setReplyTo(comment);
        setOpenPopoverId(null);
        setShowEditorPopover(true)
        setTimeout(() => {
          inputRef.current?.focus?.();
        }, 100);
      }}
    >
      Reply
    </div>

    {comment.CREATEDBY === userInfo.email_id && (
      <div
        style={{ padding: "6px", cursor: "pointer" }}
        onClick={() => {
          setEditingCommentId(comment.ROWID);
          setCommentInput(comment.Message);
          setShowEditorPopover(true)
          setReplyTo(null);
          setOpenPopoverId(null);
          setTimeout(() => {
            inputRef.current?.focus?.();
          }, 100);
        }}
      >
        Edit
      </div>
    )}

    <div
      style={{ padding: "6px", cursor: "pointer" }}
      onClick={() => {
        navigator.clipboard.writeText(comment.Message);
        message.success("Copied!");
        setOpenPopoverId(null);
      }}
    >
      Copy
    </div>

    {comment.CREATEDBY === userInfo.email_id && (
      <div
        style={{ padding: "6px", cursor: "pointer" }}
        onClick={() => togglePinComment(comment.ROWID)}
      >
        {pinnedCommentId === comment.ROWID ? "Unpin" : "Pin"}
      </div>
    )}

    {comment.CREATEDBY === userInfo.email_id && (
      <div
        style={{ padding: "6px", cursor: "pointer", color: "red" }}
        onClick={() => deleteComment(comment.ROWID)}
      >
        Delete
      </div>
    )}
  </div>
);
  function highlightComment(ROWID) {
    const el = commentRefs.current[ROWID];
    if (!el) return;
    el.style.transition = "background-color 0.3s ease";
    el.style.backgroundColor = "#ebfbebff";
    setTimeout(() => {
      el.style.backgroundColor = "";
    }, 1500);
  }
  const getUserNameByEmail = (email) => {
    const user = allUsers.find((u) => u.email === email);
    return user?.full_name || email;
  };

  const truncateMessage = (html, maxLength) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";

    return text.length > maxLength
      ? text.slice(0, maxLength) + "..."
      : text;
  };
  return (
    <div
      style={{ display: "flex", flexDirection: "column", height: "100%",
        width: taskListComment ? "685px" : "100%",
        maxHeight: taskListComment ? "390px" : undefined,
        background: "#ffffff", borderRadius: "10px", overflow: "hidden" }}>

        {pinnedComment && (
          <div
            style={{
              background: "#ffffff",
              padding: "6px 12px",
              fontSize: "13px",
              border: "1px solid #ffeeba",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <div
              onClick={() => {
                const el = commentRefs.current[pinnedComment.ROWID];
                if (el) {
                  el.scrollIntoView({ behavior: "smooth", block: "center" });
                  highlightComment(pinnedComment.ROWID);
                }
              }}
              style={{
                background: "#f0f0f0",
                padding: "4px 8px",
                borderRadius: "6px",
                cursor: "pointer",
                maxWidth: "85%"
              }}
            >
              <div
                style={{
                  fontSize: "11px",
                  color: "#555",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                }}
              >
                📌 {truncateMessage(pinnedComment.Message, 60)}
              </div>
            </div>

            <span
              style={{
                cursor: "pointer",
                fontWeight: "bold",
                marginLeft: "10px"
              }}
              onClick={() => togglePinComment(pinnedComment.ROWID)}
            >
              ✕
            </span>
          </div>
        )}     
      <div style={{ flex: 1, overflowY: "auto", padding: "5px", display: "flex", flexDirection: "column" }} >
        {comments.map((comment, index) => {

          const currentDate = new Date(comment.CREATEDTIME);
          const previousComment = comments[index - 1];

          const showDateSeparator =
            !previousComment ||
            !isSameDay(new Date(previousComment.CREATEDTIME), currentDate);

          const isMine = comment.CREATEDBY === userInfo.email_id;
          const sender = getUserDetails(comment.CREATEDBY);
          const reactions = comment.Reactions
            ? typeof comment.Reactions === "string"
              ? JSON.parse(comment.Reactions)
              : comment.Reactions
            : [];
          return (
            <>
              {showDateSeparator && (
                <div style={{ alignSelf: "center", background: "#00a1ff36 " /*"#ffffff"*/, color: "#54656f", fontSize: "12px", padding: "4px 10px", borderRadius: "8px", margin: "8px 0", boxShadow: "0 1px 1px rgba(0,0,0,0.08)" }}>
                  {getDateLabel(comment.CREATEDTIME)}
                </div>
              )}

              <div key={comment.ROWID} 
              ref={(el) => {
                commentRefs.current[comment.ROWID] = el;
              }}
              style={{ display: "flex", alignItems: "flex-start", justifyContent: isMine ? "flex-end" : "flex-start", marginBottom: "22px" }}>

                {!isMine && (
                  <img className="User-Image" src={getUserThumbnailUrl(sender.zuid)} />
                )}

                <div
                  style={{
                    backgroundColor: isMine ? "#a2efb4ff" : "#ede7e7ff",
                    color: "#000",
                    padding: "6px 12px",
                    borderRadius: "8px",
                    maxWidth: "65%",
                    fontSize: "12px",
                    boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
                    position: "relative"
                  }}
                  onMouseEnter={() => setHoveredId(comment.ROWID)}
                  onMouseLeave={() => setHoveredId(null)}
                >

                  {!isMine && (
                    <div style={{ fontSize: "10px", fontWeight: "600", color: "#128C7E", marginBottom: "3px" }}>
                      {sender?.full_name || comment.CREATEDBY}
                    </div>
                  )}
                  {comment.ReplyTo && (() => {
                    const parent = comments.find(c => c.ROWID == comment.ReplyTo);
                    if (!parent) return null;

                    return (
                      <div
                        onClick={() => {
                          const el = commentRefs.current[parent.ROWID];
                          if (el) {
                            el.scrollIntoView({ behavior: "smooth", block: "center" });
                            highlightComment(parent.ROWID);
                          }
                        }}
                        style={{
                          background: isMine ? "#ffffff90" : "#f0f0f0",
                          borderLeft: "4px solid #25D366",
                          padding: "1px 5px",
                          borderRadius: "6px",
                          marginBottom: "1px",
                          cursor: "pointer"
                        }}
                      >
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            color: "#25D366",
                            // marginBottom: "2px"
                          }}
                        >
                          {getUserNameByEmail(parent.CREATEDBY)}
                        </div>

                        <div
                          style={{
                            fontSize: "10px",
                            color: "#555",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "220px"
                          }}
                        >
                          {truncateMessage(parent.Message, 40)}
                        </div>
                      </div>
                    );
                  })()}
                  {renderMessage(comment.Message)}

                  <div style={{ fontSize: "10px", color: "#667781", textAlign: "right", /*marginTop: "4px"*/ }}>
                    {formatTime(comment.CREATEDTIME)}
                  </div>
                  {reactions?.length > 0 && (() => {

                    const grouped = reactions.reduce((acc, r) => {
                      acc[r.emoji] = acc[r.emoji] || [];
                      acc[r.emoji].push(r.user);
                      return acc;
                    }, {});

                    const entries = Object.entries(grouped);
                    const visible = entries.slice(0, 3);

                    return (
                      <div
                        style={{
                          position: "absolute",
                          bottom: "-18px",
                          right: isMine ? "0" : "auto",
                          left: !isMine ? "0" : "auto",
                          display: "flex",
                          gap: "4px"
                        }}
                      >
                        {visible.map(([emoji, users]) => {

                          const userHasReacted = users.includes(userInfo.email_id);

                          return (
                            <span
                              key={emoji}
                              title={users.map(u => getUserNameByEmail(u)).join(", ")}
                              onClick={() => {
                                if (userHasReacted) {
                                  handleReactToComment(comment.ROWID, emoji, true);
                                }
                              }}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "3px",
                                padding: "2px 6px",
                                borderRadius: "12px",
                                background: "#fff",
                                border: "1px solid #ddd",
                                fontSize: "12px",
                                cursor: "pointer",
                                boxShadow: "0 1px 2px rgba(0,0,0,0.15)"
                              }}
                            >
                              {emoji}
                              {users.length > 1 && (
                                <span style={{ fontSize: "11px" }}>{users.length}</span>
                              )}
                            </span>
                          );
                        })}
                      </div>
                    );

                  })()}
                  {(hoveredId === comment.ROWID ||
                    openPopoverId === comment.ROWID) && (
                    <Popover
                      content={popoverContent(comment)}
                      trigger="click"
                      placement="topRight"
                      open={openPopoverId === comment.ROWID}
                      onOpenChange={(visible) =>
                        setOpenPopoverId(
                          visible ? comment.ROWID : null
                        )
                      }
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: "-10px",
                          right: "-10px",
                          width: "24px",
                          height: "24px",
                          borderRadius: "50%",
                          background: "#fff",
                          border: "1px solid #ddd",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                          fontWeight: "bold",
                          boxShadow:
                            "0 2px 5px rgba(0,0,0,0.15)"
                        }}
                      >
                        +
                      </div>
                    </Popover>
                  )}
                </div>
              </div>
            </>
          );
        })}

        <div ref={bottomRef}></div>
      </div>
      
      <div style={{ padding: "10px 14px", background: "#f0f2f5", display: "flex", alignItems: "center", gap: "8px" }}>

        {!showEditorPopover && (
          <div
            style={{
              flex: 1,
              background: "#ffffff",
              borderRadius: "25px",
              padding: "6px 12px",
              cursor: "text",
              minHeight: "36px",
              display: "flex",
              alignItems: "center",
              fontSize: "14px",
              color: commentInput ? "#000" : "#a0a0a0"
            }}
            onClick={() => setShowEditorPopover(true)}
          >
            {"Type a message..."}
          </div>
        )}

        <CommentEditor
          showEditorPopover={showEditorPopover}
          setShowEditorPopover={(val) => {setShowEditorPopover(val); setEditingCommentId(null)}}
          replyTo={replyTo}
          setReplyTo={setReplyTo}
          commentInput={commentInput}
          setCommentInput={setCommentInput}
          saveCommentForTask={saveCommentForTask}
          messageBehavior={messageBehavior}
          messageBehaviorRef={messageBehaviorRef}
          action = {editingCommentId ? "Edit" : ""}
          editorType = {createTaskModal ? "Comment" : "CommentList"}
        />
      </div>
    </div>
  );
};

export default TaskCommentSection;